<template>
    <div class="dock-calendar-icon">
        <div class="dock-calendar-inner">
            <div class="dock-calendar-header" :class="{'dock-calendar-header--dimmed': hasBadge}">
                <span class="dock-calendar-day-name">{{ dayName }}</span>
            </div>
            <div class="dock-calendar-body">
                <span class="dock-calendar-date">{{ dayNumber }}</span>
            </div>
        </div>
        <span v-if="showBadge && pendingCount > 0" class="dock-calendar-badge">{{ badgeText }}</span>
    </div>
</template>

<script>
import agendaBadgeService from './agendaBadgeService'

const DAY_NAMES_TR = ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt']

export default {
    name: 'DockCalendarIcon',
    data() {
        return {
            now: new Date(),
        }
    },
    computed: {
        dayName() {
            return DAY_NAMES_TR[this.now.getDay()]
        },
        dayNumber() {
            return this.now.getDate()
        },
        showBadge() {
            return agendaBadgeService.state.dockBadge
        },
        pendingCount() {
            return agendaBadgeService.state.pendingCount
        },
        badgeText() {
            return this.pendingCount > 99 ? '99+' : String(this.pendingCount)
        },
        hasBadge() {
            return this.showBadge && this.pendingCount > 0
        },
    },
    mounted() {
        this._scheduleNextDay()
        agendaBadgeService.restoreSettings()
        agendaBadgeService.init()
    },
    beforeUnmount() {
        clearTimeout(this._timer)
        agendaBadgeService.destroy()
    },
    methods: {
        _scheduleNextDay() {
            const now = new Date()
            const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)
            const ms = tomorrow - now + 1000
            this._timer = setTimeout(() => {
                this.now = new Date()
                this._scheduleNextDay()
            }, ms)
        },
    },
}
</script>

<style scoped>
.dock-calendar-icon {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: visible;
}

.dock-calendar-icon span {
    display: block;
}

.dock-calendar-inner {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 22.5%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #F0EBE3;
}

.dock-calendar-header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28%;
    background: #E8453C;
    transition: background 0.2s ease;
    line-height: 1;
}

.dock-calendar-day-name {
    font-size: calc(var(--dock-icon-size, 48px) * 0.18);
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.dock-calendar-body {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.dock-calendar-date {
    font-size: calc(var(--dock-icon-size, 48px) * 0.46);
    font-weight: 300;
    color: #3a3228;
    line-height: 1;
    margin-top: -2px;
}

.dock-calendar-inner::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 22.5%;
    box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);
    pointer-events: none;
}

html.dark .dock-calendar-header--dimmed,
html.midnight .dock-calendar-header--dimmed {
    background: #9B2C2C;
}

html.dark .dock-calendar-inner::after,
html.midnight .dock-calendar-inner::after {
    box-shadow: none;
}

html.dark .dock-calendar-inner {
    background: #2D3036;
}

html.dark .dock-calendar-date {
    color: #E0E2E6;
}

html.midnight .dock-calendar-inner {
    background: #252830;
}

html.midnight .dock-calendar-date {
    color: #D8DAE0;
}

.dock-calendar-badge {
    --_icon: var(--dock-icon-size, 48px);
    --_h: calc(var(--_icon) * 0.42);
    display: flex !important;
    position: absolute;
    top: calc(var(--_h) * -0.3);
    right: calc(var(--_h) * -0.25);
    min-width: var(--_h);
    height: var(--_h);
    border-radius: calc(var(--_h) / 2);
    font-size: calc(var(--_icon) * 0.21);
    background: #EF4444;
    color: #fff;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    line-height: 1;
    padding: 1.4px 0 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    pointer-events: none;
    z-index: 1;
    transition: min-width 0.12s ease-out, height 0.12s ease-out, font-size 0.12s ease-out, top 0.12s ease-out, right 0.12s ease-out;
}
</style>
